import { BaseDeviceWrapper } from "./BaseDeviceWrapper";
import imageVickNeo2 from "images/devices/vickNeo2-promotion.png";

const serviceUuid = 0xffe0;
const characteristicUuid = 0xffe1;

const devices = [{ name: "Vick Neo 2", image: imageVickNeo2 }];

const MAX_INTENSITY = 0x0a;

/**
 * Create a device wrapper over the Web Bluetooth device object
 * @param {obj} webBleDevice - Web Bluetooth device object
 */
export default class SvakomVickNeo2 extends BaseDeviceWrapper {
  constructor(device, isSendingData) {
    const deviceRec = devices.find((d) => d.name === device.name);
    if (!deviceRec) {
      throw Error(`Device ${device.name} is not supported`);
    }
    super(
      device,
      serviceUuid,
      characteristicUuid,
      imageVickNeo2,
      isSendingData
    );
  }

  static get deviceNames() {
    return devices.map((d) => d.name);
  }

  /**
   * Needed to request access to these services before connecting to the device
   */
  static get services() {
    return [serviceUuid];
  }

  get companyName() {
    return "Svakom";
  }

  async write(percent) {
    const intensity = Math.max(
      0,
      Math.min(MAX_INTENSITY, (percent * MAX_INTENSITY) / 100)
    );
    const data = intensity
      ? [0x55, 0x03, 0x00, 0x00, 0x01, intensity, 0x00]
      : [0x55, 0x03, 0x00, 0x00, 0x00, 0x00, 0x00];
    const array = new Uint8Array(data);
    await this.motorChar.writeValue(array);
  }
}
